export default {
  TITLE: {
    title: 'Update Payment'
  },
  COUPON_CODE_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'Invalid coupon code.'
  },
  COUPON_CODE_SUCCESS: {
    severity: 'success' as 'success',
    title: 'Success!',
    subtitle: 'Your coupon code has been applied!'
  },
  GET_ERROR: {
    title: 'There was an issue fetching payment information'
  },
  UPDATE_PAYMENT_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh',
    subtitle: 'The payment method entered was declined.'
  },
  PAYMENT_COST_MORE_INFO_URL:
    'https://intermountainhealthcare.org/services/urgent-care/connect-care/billing-insurance/'
};
